import './App.css';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Learn from './Screens/Learn/Learn';
import Admin from './Screens/Admin/Admin';
import Login from './Screens/Login/Login';
import Report from './Screens/Report/Report';
import Explore from './Screens/Explore/Explore';
import Setting from './Screens/Setting/Setting';
import Contact from './Screens/Contact/Contact';
import Navbar from './Components/Navbar/Navbar';
import Reset from './Screens/ResetPassword/Reset';
import MyBounty from './Screens/MyBounty/MyBounty';
import Register from './Screens/Register/Register';
import Homepage from './Screens/Homepage/Homepage';
import Payments from './Screens/Payments/payments';
import { allBounty } from './actions/bounty.action';
import { allPayment } from './actions/payment.action';
import Dashboard from './Screens/Dashboard/Dashboard';
import Addbounty from './Screens/AddBounty/Addbounty';
import Submission from './Screens/Submission/Submission';
import Howitworks from './Screens/Howitworks/Howitworks';
import VerifyTwoFA from './Screens/verify2FA/verifyTwoFA';
import Bounty from './Screens/Explore/BountyByName/Bounty';
import { Route, Routes, Navigate, Link } from 'react-router-dom';
import UpdatePassword from './Screens/ResetPassword/UpdatePassword/UpdatePassword';
import Org from './Screens/Dashboard/Org/Org';
import EmailVerify from './Screens/EmailVerification/EmailVerify';
import Kyc from './Screens/kyc/kyc';
import Career from './Screens/Career.js/Career';

const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(allBounty());
    dispatch(allPayment());
  }, [dispatch]);

  const user = JSON.parse(localStorage.getItem('curUser'));
  const validate = JSON.parse(localStorage.getItem('validate'));

  return (
    <div className='App'>
      {user != null ? (
        user.user.isAdmin ? (
          <div
            style={{
              backgroundColor: 'rgb(204, 63, 204)',
              padding: '5px 60px',
              textAlign: 'right',
              display: 'flex',
              justifyContent: 'Right',
            }}
          >
            <Link
              to='/admin'
              style={{
                textDecoration: 'none',
                width: 'fit-content',
                textAlign: 'right',
                cursor: 'pointer',
                color: 'white',
              }}
            >
              <i className='fas fa-user' style={{ marginRight: '5px' }} /> Admin
              Panel
            </Link>
          </div>
        ) : null
      ) : null}
      <Navbar />
      <Routes>
        <Route exact path='/' element={<Homepage />} />
        <Route exact path='/career' element={<Career />} />
        <Route
          path='/kyc'
          element={user === null ? <Navigate replace to='/' /> : <Kyc />}
        />
        <Route
          exact
          path='/admin/*'
          element={
            user === null ? (
              <Navigate replace to='/' />
            ) : user.user.isAdmin ? (
              <Admin />
            ) : (
              <Navigate replace to='/dashboard' />
            )
          }
        />
        <Route
          exact
          path='/login'
          element={user ? <Navigate replace to='/dashboard' /> : <Login />}
        />
        <Route exact path='/learn' element={<Learn />} />
        <Route exact path='/howitworks' element={<Howitworks />} />
        <Route
          exact
          path='/signup'
          element={user ? <Navigate replace to='/dashboard' /> : <Register />}
        />
        <Route exact path='/setting' element={<Setting />} />
        <Route
          exact
          path='/bounty'
          element={
            user && user.user.isOrg ? (
              <MyBounty />
            ) : (
              <Navigate replace to='/dashboard' />
            )
          }
        />
        <Route exact path='/explore' element={<Explore />} />
        <Route exact path='/payments' element={<Payments />} />
        <Route exact path='/bounty/:id' element={<Bounty />} />
        <Route exact path='/verify-email/' element={<EmailVerify />} />
        <Route
          exact
          path='/dashboard'
          element={
            user && user.user.isOrg ? (
              <Navigate replace to='/org_dashboard' />
            ) : (
              <Dashboard />
            )
          }
        />
        <Route
          exact
          path='/addbounty'
          element={
            user && user.user.isOrg ? (
              <Addbounty />
            ) : (
              <Navigate replace to='/dashboard' />
            )
          }
        />
        <Route
          exact
          path='/org_dashboard'
          element={
            user && user.user.isOrg ? <Org /> : <Navigate replace to='/' />
          }
        />
        <Route exact path='/forget-password' element={<Reset />} />
        <Route exact path='/new-submission' element={<Report />} />
        <Route
          exact
          path='/verify'
          element={
            validate ? <VerifyTwoFA /> : <Navigate replace to='/login' />
          }
        />
        <Route
          exact
          path='/submission/:reportId/:id'
          element={user ? <Submission /> : <Navigate replace to='/' />}
        />
        <Route
          exact
          path='/reset-password/:id/:token'
          element={<UpdatePassword />}
        />
        <Route exact path='/contact' element={<Contact />} />
      </Routes>
    </div>
  );
};

export default App;
